var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:(input)=> this.input = input,staticClass:"editable-title",class:{'cursor-not-allowed': _vm.disabled},attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"click":function($event){$event.stopPropagation();return _vm.edit.apply(null, arguments)},"blur":_vm.updateTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }